/**
 * サーバーステータス監視用の型定義
 */

/**
 * システムリソース使用状況
 */
export interface SystemResourceUsage {
  readonly memoryUsedPercent: number;
  readonly memoryTotalMB: number;
  readonly memoryUsedMB: number;
  readonly swapUsedPercent: number;
  readonly cpuLoadAverage: number;
  readonly diskUsedPercent: number;
}

/**
 * コンテナステータスの値
 */
export type ContainerStatusValue = 'running' | 'stopped' | 'restarting' | 'unknown';

/**
 * Dockerコンテナの状態
 */
export interface ContainerStatus {
  readonly name: string;
  readonly memoryUsedMB: number;
  readonly memoryLimitMB: number;
  readonly cpuPercent: number;
  readonly status: ContainerStatusValue;
}

/**
 * サーバーステータスAPIレスポンスのデータ部分
 */
export interface ServerStatusData {
  readonly system: SystemResourceUsage;
  readonly containers: readonly ContainerStatus[];
  readonly timestamp: string;
}

/**
 * サーバーステータスAPIレスポンス
 */
export interface ServerStatusResponse {
  readonly success: boolean;
  readonly data: ServerStatusData;
}

/**
 * リソース種別
 */
export type ResourceType = 'memory' | 'swap' | 'cpu' | 'disk';

/**
 * リソース閾値定数
 */
export const RESOURCE_THRESHOLDS = {
  /** 警告レベル（%） */
  WARNING: 70,
  /** 危険レベル（%） */
  CRITICAL: 85,
} as const;

/**
 * リソースの表示名
 */
export const RESOURCE_LABELS: Record<ResourceType, string> = {
  memory: 'メモリ',
  swap: 'スワップ',
  cpu: 'CPU負荷',
  disk: 'ディスク',
} as const;
